<template lang="pug">
  .session
    Frame
      .session__title Welcome back,
        .session__title-name {{ name }}!
      .session__subtitle {{ scoreText }}
        nobr  is {{ bestScore }} points.
      p.session__text(v-if="!isAttempts") This score will&nbsp;be&nbsp;entered into&nbsp;the&nbsp;race-off for&nbsp;the&nbsp;prize. You&nbsp;can
        b  buy one&nbsp;more Kaspersky&nbsp;Lab product to&nbsp;participate again or&nbsp;play without code for&nbsp;fun.
      p.session__text.session__text_big-margin(v-else) You have
        b  {{ attemptValue }}
        |  left to&nbsp;show the&nbsp;best result.
      Buttons(:type="currentButtons")
</template>

<script>
import { mapGetters } from 'vuex';
import Frame from '@/components/UI/Frame';
import Buttons from '@/components/UI/Buttons';

export default {
  name: 'Session',
  components: { Frame, Buttons },
  computed: {
    ...mapGetters(['bestScore', 'tries', 'name']),
    isAttempts() {
      return this.tries !== 0;
    },
    attemptValue() {
      return this.tries === 1 ? 'last attempt' : `${this.tries} attempts`;
    },
    scoreText() {
      return this.isAttempts ? 'Your best score' : 'You scored';
    },
    currentButtons() {
      return this.isAttempts ? 'play' : 'enter';
    },
  },
};
</script>

<style lang="scss">
  .session {
    &__title {
      @include typo-h1;
      color: $clr-main;
      &-name {
        color: $clr-darkMain;
      }
    }
    &__subtitle {
      @include typo-text(bold);
      color: $clr-darkMain;
      margin: 20px 0 0;
      @media (max-width: $max-width-xs) {
        margin: 15px 0 0;
      }
    }
    &__text {
      @include typo-text;
      color: $clr-blue;
      margin: 25px 0 0;
      @media (max-width: $max-width-xs) {
        @include typo-p(normal);
        margin: 18px 0 0;
      }
      &_big-margin {
        margin: 35px 0 0;
        @media (max-width: $max-width-xs) {
          margin: 23px 0 0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Session.vue